// YERİ: src/app/core/i18n/app-directionality.ts
//
// CDK'ya sayfanın GERÇEK yönünü söyleyen servis.
//
// SORUN: Angular CDK yönü `Directionality`den okur ve o servis değeri yalnız
// UYGULAMA AÇILIRKEN bir kez `<html dir>`den alır; sonradan DOM'da değişirse
// haberi olmaz. Portal dili Arapça/Farsça yapıldığında PortalThemeService
// `<html dir="rtl">` yazıyor, CSS dönüyor — ama CDK hâlâ 'ltr' sanıyor.
//
// Sonuç: `originX: 'end'` gibi MANTIKSAL konumlar fiziksel olarak yorumlanıyor
// ve açılır menüler yanlış tarafa kayıyor. (Üst bardaki kullanıcı menüsü RTL'de
// sola kayıyordu — tam olarak bu.)
//
// Bu servis `Directionality` yerine geçer ve yön değiştiğinde `change` yayar;
// CDK'nın konum stratejileri o olayı dinliyor, yani açık katmanlar da düzelir.
// Tek bir açılır menüyü elle "ters çevirmek" yerine kaynağı düzeltmek gerekiyordu:
// aynı hata dialog, tooltip ve menü bileşenlerinde de vardı.

import { Direction, Directionality } from '@angular/cdk/bidi';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppDirectionality extends Directionality {
  /** Yönü günceller ve CDK'yı haberdar eder. Aynı değerde hiçbir şey yapmaz. */
  setDirection(dir: Direction): void {
    if (this.value === dir) return;

    // CDK 21: `value` artık yalnız getter (valueSignal'ı okur); ona atama
    // "Cannot set property value ... which has only a getter" ile patlıyordu ve
    // RTL geçişi sessizce çalışmıyordu. Kaynağı, yani sinyali güncelle.
    this.valueSignal.set(dir);
    this.change.emit(dir);
  }
}
